import { render, staticRenderFns } from "./FormDataTransport.vue?vue&type=template&id=ba6250c4&scoped=true&"
import script from "./FormDataTransport.vue?vue&type=script&lang=js&"
export * from "./FormDataTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6250c4",
  null
  
)

export default component.exports